import type {App} from 'vue';
import Swal from 'sweetalert2';

export const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

export default {
    install(app: App) {
        app.config.globalProperties.$toast = Toast;
    }
};